// src/components/AnonymizationProfilesPage/AnonymizationProfilesPage.jsx
import React from 'react';
import { Container, Grid, Paper, Typography, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import Sidebar from '../Sidebar/Sidebar';
import useAuth from '../../hooks/useAuth';

import AnonymizationProfilesPanel from './AnonymizationProfilesPanel';
import AnonymizationProfilesHelp from './AnonymizationProfilesHelp';

const AnonymizationProfilesPage = ({ processType }) => {
    const { isLoggedIn, user, isLoading } = useAuth();
    const { t } = useTranslation();
    const isPseudo = processType === "pseudonymization";

    const renderSkeleton = () => (
        <>
            <Sidebar user={user} />
            <Container maxWidth="xl">
                <Paper 
                    elevation={0}
                    sx={{ 
                        p: { xs: 2, md: 4 }, 
                        mt: 4, 
                        borderRadius: 3, 
                        border: '1px solid',
                        borderColor: 'divider',
                        bgcolor: 'background.paper'
                    }}
                >
                    <Skeleton variant="text" width={260} height={50} />
                    <Skeleton variant="text" width={420} height={32} />
                    <Skeleton variant="rectangular" height={260} sx={{ mt: 3, borderRadius: 2 }} />
                </Paper>
            </Container>
        </>
    );

    if (!isLoggedIn || isLoading) {
        return renderSkeleton();
    }

    return (
        <>
            <Sidebar user={user} />
            <Container maxWidth="xl" sx={{ mb: 6 }}>
                <Paper 
                    elevation={0}
                    sx={{ 
                        p: { xs: 2, md: 4 }, 
                        mt: 4, 
                        borderRadius: 3, 
                        border: '1px solid',
                        borderColor: 'divider',
                        bgcolor: 'background.paper',
                    }}
                >
                    <Grid container spacing={4}>
                        <Grid item xs={12}>
                            <Typography variant="h4" sx={{ fontWeight: 700, color: 'text.primary', mb: 1 }}>
                                {isPseudo
                                    ? t('pseudoProfiles.pageTitle', 'Profily pseudonymizácie')
                                    : t('anonymizationProfiles.pageTitle', 'Anonymizačné profily')}
                            </Typography>
                            <Typography variant="subtitle1" sx={{ color: 'text.secondary', fontSize: '1.1rem' }}>
                                {t(
                                    'anonymizationProfiles.pageSubtitle',
                                    'Vytvor si a spravuj profily anonymizácie, ktoré potom môžeš použiť pri anonymizácii súborov.'
                                )}
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <AnonymizationProfilesHelp t={t} />
                        </Grid>

                        <Grid item xs={12}>
                            <AnonymizationProfilesPanel processType={processType} />
                        </Grid>
                    </Grid>
                </Paper>
            </Container>
        </>
    );
};

export default AnonymizationProfilesPage;